import { render, staticRenderFns } from "./edc-submitted-form-new.vue?vue&type=template&id=b3a55f7c&scoped=true&"
import script from "./edc-submitted-form-new.vue?vue&type=script&lang=js&"
export * from "./edc-submitted-form-new.vue?vue&type=script&lang=js&"
import style0 from "../../../public/static/fonts.scss?vue&type=style&index=0&id=b3a55f7c&scoped=true&lang=scss&"
import style1 from "./edc-submitted-form-new.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3a55f7c",
  null
  
)

component.options.__file = "edc-submitted-form-new.vue"
export default component.exports